import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { ChevronDown, ChevronUp } from "@tamagui/lucide-icons";
import { Sheet } from "@tamagui/sheet";
import { useState } from "react";
import { Button, H1, H2, Input, Paragraph, XStack } from "tamagui";
const SheetDemo = () => {
  const [position, setPosition] = useState(0);
  const [open, setOpen] = useState(false);
  const [modal, setModal] = useState(false);
  const [innerOpen, setInnerOpen] = useState(false);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(XStack, { space: true, children: [
      /* @__PURE__ */ jsx(Button, { onPress: () => setOpen(true), children: "Open" }),
      /* @__PURE__ */ jsx(Button, { onPress: () => setModal((x) => !x), children: modal ? "Type: Modal" : "Type: Inline" })
    ] }),
    /* @__PURE__ */ jsxs(
      Sheet,
      {
        forceRemoveScrollEnabled: open,
        modal,
        open,
        onOpenChange: setOpen,
        snapPoints: [85, 50, 25],
        dismissOnSnapToBottom: true,
        position,
        onPositionChange: setPosition,
        zIndex: 1e5,
        animation: "bouncy",
        children: [
          /* @__PURE__ */ jsx(Sheet.Overlay, {}),
          /* @__PURE__ */ jsx(Sheet.Handle, {}),
          /* @__PURE__ */ jsxs(
            Sheet.Frame,
            {
              flex: 1,
              padding: "$4",
              justifyContent: "center",
              alignItems: "center",
              space: "$5",
              children: [
                /* @__PURE__ */ jsx(Button, { size: "$6", circular: true, icon: ChevronDown, onPress: () => setOpen(false) }),
                /* @__PURE__ */ jsx(Input, { width: 200 }),
                modal && /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx(InnerSheet, { open: innerOpen, onOpenChange: setInnerOpen }),
                  /* @__PURE__ */ jsx(
                    Button,
                    {
                      size: "$6",
                      circular: true,
                      icon: ChevronUp,
                      onPress: () => setInnerOpen(true)
                    }
                  )
                ] })
              ]
            }
          )
        ]
      }
    )
  ] });
};
function InnerSheet(props) {
  return /* @__PURE__ */ jsxs(Sheet, { modal: true, snapPoints: [90], dismissOnSnapToBottom: true, ...props, children: [
    /* @__PURE__ */ jsx(Sheet.Overlay, {}),
    /* @__PURE__ */ jsx(Sheet.Handle, {}),
    /* @__PURE__ */ jsx(Sheet.Frame, { flex: 1, justifyContent: "center", alignItems: "center", space: "$5", children: /* @__PURE__ */ jsxs(Sheet.ScrollView, { padding: "$4", space: true, children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          size: "$8",
          circular: true,
          alignSelf: "center",
          icon: ChevronDown,
          onPress: () => {
            var _a;
            return (_a = props.onOpenChange) == null ? void 0 : _a.call(props, false);
          }
        }
      ),
      /* @__PURE__ */ jsx(H1, { children: "Hello world" }),
      /* @__PURE__ */ jsx(H2, { children: "You can scroll me" }),
      [1, 2, 3].map((i) => /* @__PURE__ */ jsx(Paragraph, { size: "$10", children: "Eu officia sunt ipsum nisi dolore labore est laborum laborum in esse ad pariatur. Dolor excepteur esse deserunt voluptate labore ea. Exercitation ipsum deserunt occaecat cupidatat consequat est adipisicing velit cupidatat ullamco veniam aliquip reprehenderit officia. Officia labore culpa ullamco velit. In sit occaecat velit ipsum fugiat esse aliqua dolor sint." }, i))
    ] }) })
  ] });
}
export {
  SheetDemo
};
//# sourceMappingURL=SheetDemo.js.map
